<template>
  <div class="address">
    <div class="titulo" v-if="presonType === 'PF'">
      <h1>Informe o seu endereço</h1>
      <p>
        É importante que você saiba que será pedido posteriormente um comprovante deste endereço.
      </p>
    </div>
    <div class="titulo" v-else>
      <h1>Informe o endereço da sua empresa</h1>
      <p>
        É importante que você saiba que será pedido posteriormente um comprovante deste endereço.
      </p>
    </div>

    <div class="card-box full">
      <br>
      <form @submit="submitHandler" autocomplete="off">
        <div class="linha">
          <div class="eight">
            <label>CEP</label>
            <the-mask mask="#####-###"
                      placeholder="Digite apenas números"
                      v-model="form.zipcode"
                      :disabled="loading"/>
          </div>
          <div class="eight">
            <br/> <br/>
            <label>
              <a style="float: none" target="_blank"
                 href="http://www.buscacep.correios.com.br/sistemas/buscacep/">
                Não sabe seu CEP?
              </a>
            </label>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>Estado</label>
            <input type="text"
                   v-model="form.state"
                   placeholder="Estado"
                   maxlength="2"
                   :disabled="loading"/>
          </div>
          <div class="eight">
            <label>Cidade</label>
            <input type="text"
                   v-model="form.city"
                   placeholder="Cidade"
                   :disabled="loading"
                   maxlength="50"/>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>Bairro</label>
            <input type="text"
                   v-model="form.neighborhood"
                   placeholder="Bairro"
                   maxlength="100"
                   :disabled="loading"/>
          </div>
          <div class="eight">
            <label>Rua</label>
            <input type="text"
                   v-model="form.address1"
                   placeholder="Rua"
                   :disabled="loading"
                   maxlength="200"/>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>Número</label>
            <input type="text"
                   v-model="form.number"
                   placeholder="Número"
                   maxlength="25"
                   :disabled="loading"/>
          </div>
          <div class="eight">
            <label>Complemento</label>
            <input type="text"
                   v-model="form.address2"
                   placeholder="Complemento"
                   :disabled="loading"
                   maxlength="200"/>
          </div>
        </div>

        <div class="erroDados" v-if="invalid">
          Endereço Invalido
        </div>

        <ContinueSection enable-back
                         :enable-continue="!invalid"
                         @back="$emit('back')"/>
      </form>
    </div>
  </div>
</template>

<script>
import ContinueSection from '@/components/ContinueSection'
import cep from '@/common/lib/cep'

export default {
  name: 'Address',
  components: { ContinueSection },
  model: {
    prop: 'address',
    event: 'submit'
  },
  props: {
    address: Object,
    presonType: String
  },
  data: () => ({
    watch: false,
    loading: false,
    invalid: false,
    form: {
      zipcode: '',
      state: '',
      city: '',
      neighborhood: '',
      address1: '',
      address2: '',
      number: ''
    }
  }),
  methods: {
    submitHandler(e) {
      e.preventDefault()

      const {
        invalid, form: {
          zipcode, state, city, neighborhood, address1, number
        }
      } = this

      this.invalid = !!(
        invalid
        || !zipcode
        || !state
        || !city
        || !neighborhood
        || !address1
        || !number
      )

      !this.invalid && this.$emit('submit', this.form)
    }
  },
  watch: {
    address(address) {
      this.watch = false

      this.form = { ...address }

      setTimeout(() => this.watch = true, 300)
    },
    'form.zipcode': async function (zipcode) {
      if (!this.watch || zipcode.length < 8) {
        return
      }

      Object.assign(this.form, {
        state: '',
        city: '',
        neighborhood: '',
        address1: '',
        address2: ''
      })

      this.loading = true

      const data = await cep(zipcode)

      this.loading = false

      this.invalid = !data

      if (this.invalid) {
        return
      }

      const {
        uf, localidade, bairro, logradouro, logradouro_complemento: complemento
      } = data

      Object.assign(this.form, {
        state: uf,
        city: localidade,
        neighborhood: bairro,
        address1: logradouro,
        address2: complemento
      })
    }
  },
  created() {
    this.form = { ...this.address }

    setTimeout(() => this.watch = true, 300)
  }
}
</script>
